import React, { useState } from 'react';
import ContactForm from './ContactForm';
import Button from './ui/Button';
import Icon from './AppIcon';

const ContactModal = ({ 
  isOpen, 
  onClose, 
  initialIssueType = null, 
  sourcePage = null,
  sourceUrl = null,
  metadata = {},
  title = "Contact Support"
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  if (!isOpen) return null;

  const handleSuccess = (data) => {
    setIsSubmitted(true);
    // Auto-close after 3 seconds
    setTimeout(() => {
      handleClose();
    }, 3000);
  };

  const handleClose = () => {
    setIsSubmitted(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 bg-background/95 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="MessageSquare" size={20} className="text-primary" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">{title}</h3>
              <p className="text-sm text-muted-foreground">
                Get help with your issue
              </p>
            </div>
          </div>
          <Button 
            variant="ghost" 
            size="sm" 
            iconName="X" 
            onClick={handleClose}
            className="text-muted-foreground hover:text-foreground"
          />
        </div>

        {/* Modal Content */}
        <div className="p-6">
          <ContactForm
            onSuccess={handleSuccess}
            onCancel={handleClose}
            initialIssueType={initialIssueType}
            sourcePage={sourcePage}
            sourceUrl={sourceUrl}
            metadata={metadata}
            showTitle={false}
            compact={true}
          />
        </div>
      </div>
    </div>
  );
};

// Hook for easy modal management
export const useContactModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState({});

  const openModal = (props = {}) => {
    setModalProps(props);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalProps({});
  };

  const ContactModalComponent = () => (
    <ContactModal
      isOpen={isOpen}
      onClose={closeModal}
      {...modalProps}
    />
  );

  return {
    openModal,
    closeModal,
    ContactModal: ContactModalComponent,
    isOpen
  };
};

export default ContactModal;
